// extracted by mini-css-extract-plugin
export default {"titleSection":"Tokens_titleSection__8Zo28","titleWrapper":"Tokens_titleWrapper__12QlD","title":"Tokens_title__KmUEY","tokens":"Tokens_tokens__JdynM"};